module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/tag/tag-admin.component.css
// module id = ./src/app/admin/tag/tag-admin.component.css
// module chunks = main